export default function trackEvent(name, params = {}) {
  if (typeof gtag === "function") {
    // gtag is defined in index.html
    // eslint-disable-next-line no-undef
    gtag("event", name, params);
  }
}
